export const MAIN_PRODUCT_CHECKOUT_URL =
  'https://rutinasimple.com//cart/52838156763417:1'

type PreventableEvent = {
  preventDefault: () => void
}

/**
 * Routes bridge CTAs through the single state-aware checkout button rendered
 * by OrderBumps. The fallback prevents a silent dead click if that anchor is
 * ever unavailable during rendering.
 */
export function activateFinalCheckout(event: PreventableEvent): void {
  event.preventDefault()

  const checkoutLink =
    document.querySelector<HTMLAnchorElement>('#checkout-final a')

  if (checkoutLink) {
    checkoutLink.click()
    return
  }

  window.location.assign(MAIN_PRODUCT_CHECKOUT_URL)
}
